import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class AccountService {
    public getAccountApiForAttendee: string = "/svcs/session_catalog/app/account/";
    public getAccountByUUIDApiForAttendee: string = this.getAccountApiForAttendee + "findByUUID";
    public getAccountApi: string = "/svcs/accounts/";
    public getAccountByUUIDApi: string = this.getAccountApi + "findByUUID";

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public getAccountByUUID(uuid: string) {
        let url;
        if (this.sharedService.redirectTo == "admin") {
            url = this.getAccountByUUIDApi;
        } else {
            url = this.getAccountByUUIDApiForAttendee;
        }
        return this.http.get(url, {
            params: new HttpParams().set("uuid", uuid),
            observe: "response",
            headers: this.sharedService.headers
        });
    }
}
